import Cookies from "js-cookie";
const SupportKey='supportKey';
export function getSupport() {
  return Cookies.get(SupportKey)
}

export function setSupport(isSupport) {
  return Cookies.set(SupportKey, isSupport,{ expires: 3 })
}

export function setCookie(key,value,expires) {
  return Cookies.set(key, value,{ expires: expires})
}

export function getCookie(key) {
  return Cookies.get(key)
}

// / 设置Cookie
// export function setCookie(name, value, days) {
//   const d = new Date()
//   d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000))
//   const expires = 'expires=' + d.toUTCString()
//   document.cookie = name + '=' + value + '; ' + expires
// }

// // 获取Cookie
// export function getCookie(name) {
//   const nameEQ = name + '='
//   const ca = document.cookie.split(';')
//   for (let i = 0; i < ca.length; i++) {
//     let c = ca[i]
//     while (c.charAt(0) === ' ') c = c.substring(1, c.length)
//     if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
//   }
//   return null
// }

// // 设置支持标记
// export function setSupport(isSupport) {
//   localStorage.setItem('support', isSupport)
// }

// // 获取支持标记
// export function getSupport() {
//   return localStorage.getItem('support')
// }



// WEBPACK FOOTER //
// ./src/utils/support.js